import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import Bovines from "@/customIcons/Bovines.vue";
import Ice from "@/customIcons/Ice";
import Toxic from "@/customIcons/Toxic";
import EffluentsGranting from "@/customIcons/EffluentsGranting";
import EffluentsGrantingBase from "@/customIcons/EffluentsGrantingBase";
import UseSoil from "@/customIcons/UseSoil";
import EnvironmentalRestrictions from "@/customIcons/EnvironmentalRestrictions.vue";
import Erosion from "@/customIcons/Erosion.vue";
import ErosionMenu from "@/customIcons/ErosionMenu.vue";
import BovinesMap from "@/customIcons/BovinesMap.vue";
import Indicator from "@/customIcons/Indicador.vue";
import IceMap from "@/customIcons/IceMap";
import IceMapSub from "@/customIcons/IceMapSub";
import Restrictions from "@/customIcons/Restrictions";


Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md", // default - only for display purposes
    values: {
      bovines: {
        component: Bovines,
      },
      ice: {
        component: Ice,
      },
      toxic: {
        component: Toxic,
      },
      effluentsGranting: {
        component: EffluentsGranting,
      },
      effluentsGrantingBase: {
        component:  EffluentsGrantingBase,
      },
      useSoil: {
        component: UseSoil,
      },
      environmentalRestrictions: {
        component: EnvironmentalRestrictions,
      },
      erosion: {
        component: Erosion,
      },
      erosionMenu: {
        component: ErosionMenu,
      },
      bovinesMap: {
        component: BovinesMap,
      },
      Indicator: {
        component: Indicator,
      },
      iceMap: {
        component: IceMap,
      },

      iceMapSub: {
        component: IceMapSub,
      },
      restrictions: {
        component: Restrictions,
      },
    },
  },
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      dark: {
        dark: "#212A35",
        primary: {
          lighten1: "#008AD7",
          base: "#3643BE",
          darken1: "#212A35",
          darken2: "#2C343F",
        },
        secondary: {
          base: "#6071DB",
          lighten1: "#95A1EC",
          lighten2: "#B0BAF4",
        },
        accent: {
          base: "#A8BAC8",
        },
        black: {
          base: "#0D0D0D",
          lighten1: "#262626",
        },
        grey: {
          base: "#676A71",
          lighten1: "#D9D9D9",
          lighten2: "#F2F2F2",
          lighten3: "#595959",
        },
        yellow: {
          base: "#F39946",
        },
        green: {
          base: "#45BF55",
        },
        red: {
          base: "#FF3A00",
        },
        blue: {
          base: "#5C9ED8",
          darken1: "#2D97F2",
        },
        success: {
          base: "#52B347",
        },
        error: {
          base: "#F86A78",
        },
        warning: {
          base: "#FF7C55",
        },
      },
    },
  },
});
